import clsx from 'clsx';

interface Props {
	className?: string;
}
export const MenuButton: React.FC<Props> = ({ className }) => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={clsx('size-4', className)}
		>
			<path
				d="M1 8H15"
				stroke="#51526C"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M1 14H15"
				stroke="#51526C"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M1 2H15"
				stroke="#51526C"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
